import React, { FC } from 'react';
import { Image, View, ViewProps } from 'react-native';

import { assets } from '@assets';

import { styles } from './styles';

import { TWCText } from '../../TWCText/TWCText';
import { StepStatus } from '../types';

export const TWCStepIcon: FC<TWCStepIconProps> = ({ status, step, style }) => {
  const accessibilityLabel = status === StepStatus.INCOMPLETE ? `Step ${step ?? 1}` : `Step ${step ?? 1} ${status}`;

  return (
    <View style={[styles.container, styles[status], style]}>
      {status === StepStatus.COMPLETE && <Image source={assets.greenCheck} style={styles.completeIcon} />}
      {status === StepStatus.FAILED && <Image source={assets.redCancel} style={styles.failedIcon} />}
      {status === StepStatus.INCOMPLETE && (
        <TWCText
          noTestID
          accessibilityHint={''}
          accessibilityLabel={accessibilityLabel}
          fontFamily={'black'}
          style={styles.stepNumber}
        >
          {`${step ?? ''}`}
        </TWCText>
      )}
    </View>
  );
};

type TWCStepIconProps = {
  status: StepStatus;
  step?: number;
} & ViewProps;
